export default "__VITE_ASSET__d8c72b25__"